import { deleteRest, get, post, put } from 'utils/rxfetch'
import { buildURL } from 'utils/urls'

export default () => ({
  fetchIncidentsCount(companyId = '', dateFilter = null, state = 'open') {
    return get(
      `/members-api/incidents/count/?state=${state}&dateFilter=${dateFilter}&companyFilter=${companyId}`
    )
  },
  changeReportState(reportId, newState, reportTypePrefix) {
    return post(`/members-api/irontraps/reports/${reportTypePrefix}/${reportId}/${newState}`)
  },
  saveCommentAndTags(reportId, body, reportTypePrefix, companyId = '') {
    return put(
      `/members-api/irontraps/reports/${reportTypePrefix}/${reportId}/comments?companyFilter=${companyId}`,
      body
    )
  },
  getReportedIncidents(
    page,
    search,
    generalFilter,
    reportedByFilter,
    quickFilters,
    companyId = ''
  ) {
    return get(
      buildURL('/members-api/irontraps/history/reports', {
        page,
        search,
        generalFilter,
        quickFilters,
        companyFilter: companyId,
        reportedByFilter,
      })
    )
  },
  getRemediatedIncidents(
    page,
    search,
    generalFilter,
    reportedByFilter,
    feDateRange,
    companyId = ''
  ) {
    return post(
      buildURL('/members-api/irontraps/history/remediations', {
        companyFilter: companyId,
      }),
      {
        feDateRange,
        reportedByFilter,
        page,
        search,
        generalFilter,
      }
    )
  },
  getReport(reportId, reportTypePrefix) {
    return get(`/members-api/irontraps/incidents/${reportTypePrefix}/${reportId}`)
  },
  getAtoIncident(incidentId, page, filters) {
    return get(
      buildURL(`/members-api/irontraps/incidents/ato/${incidentId}`, {
        page,
        ...filters,
      })
    )
  },
  changeAtoIncidentState(incidentId, newState, remediationActions) {
    return post(
      `/members-api/irontraps/incident/atoaction/${incidentId}?newState=${newState}&remediationActions=${remediationActions}`
    )
  },
  getIncidentsList(
    state,
    search,
    page,
    firstPageLoadDate,
    lastRowDate,
    sortingBy,
    generalFilter,
    quickFilters,
    dateFilter,
    detectedByFilter,
    includesFilter,
    excludesFilter,
    assigneeFilter,
    resolvedFilter,
    challengedTypeFilter,
    companyId = ''
  ) {
    return post(
      buildURL('/members-api/irontraps/incidents', {
        companyFilter: companyId,
      }),
      {
        state,
        search,
        page,
        firstPageLoadDate,
        lastRowDate,
        sortingBy,
        generalFilter,
        quickFilters,
        dateFilter,
        detectedByFilter,
        includesFilter,
        excludesFilter,
        assigneeFilter,
        resolvedFilter,
        challengedTypeFilter,
      }
    )
  },
  getServerScanData(reportId, companyId = '') {
    return get(`/members-api/irontraps/serverscan/${reportId}?companyFilter=${companyId}`)
  },
  getScannerDetail(element) {
    return get(buildURL('/members-api/irontraps/scanner-detail', { element }))
  },
  getAffectedMailboxesDetail(reportId, body, isCsv = false, companyId = '') {
    const responseType = isCsv ? 'text' : 'json'
    return post(
      `/members-api/irontraps/affmailboxes-detail/${reportId}?isCsv=${isCsv}&companyFilter=${companyId}`,
      body,
      {},
      responseType
    )
  },
  updateElements(reportId, elementsName, reportTypePrefix) {
    return post(`/members-api/irontraps/scan/${reportTypePrefix}/${elementsName}/${reportId}`, {})
  },
  fetchElements(reportId, elementsName, reportTypePrefix) {
    return get(
      `/members-api/irontraps/reports/${reportTypePrefix}/${reportId}/scan?elementsName=${elementsName}`
    )
  },
  clusterUndo(body) {
    return post(`/members-api/irontraps/uncluster`, body)
  },
  revertBackToOrigin(body) {
    return post(`/members-api/irontraps/recluster`, body)
  },
  fetchTags(reportId, state, reportTypePrefix) {
    return get(`/members-api/irontraps/reports/tags/${reportTypePrefix}/${reportId}/${state}`)
  },
  editTags(reportId, type, tags, reportTypePrefix) {
    return put(
      `/members-api/irontraps/reports/resolutiontags/${reportTypePrefix}/${reportId}/${type}`,
      { tags }
    )
  },
  validateNewAffectedMailboxesSeen() {
    return post('/members-api/irontraps/new-aff-mailboxes-seen')
  },
  fetchReportComments(reportId, community, reportTypePrefix) {
    return get(
      `/members-api/irontraps/reports/${reportTypePrefix}/${reportId}/comments?community=${community}`
    )
  },
  editReportComment(reportId, commentId, body, reportTypePrefix) {
    return post(
      `/members-api/irontraps/reports/${reportTypePrefix}/${reportId}/comments?commentId=${commentId}`,
      body
    )
  },
  stopRemediation(body, companyId) {
    return post(`/members-api/irontraps/stop-clustering?companyFilter=${companyId}`, body)
  },
  deleteReportComment(reportId, commentId, reportTypePrefix) {
    return deleteRest(
      `/members-api/irontraps/reports/${reportTypePrefix}/${reportId}/comments?commentId=${commentId}`
    )
  },
  addReportComment(reportId, body, reportTypePrefix) {
    return put(`/members-api/irontraps/reports/${reportTypePrefix}/${reportId}/comments`, body)
  },
  fetchForMentionInComment(companyId = '', reportId, type, search, partner, reportTypePrefix) {
    return get(
      `/members-api/irontraps/reports/${reportTypePrefix}/${reportId}/mention/${type}?query=${search}&companyFilter=${companyId}&partner=${partner}`
    )
  },
  saveCommunityUser(nickname) {
    return put(`/members-api/irontraps/community-user?nickname=${nickname}`)
  },
  getScanbackData(companyId = '') {
    return get(`/members-api/irontraps/scanback/overview?companyFilter=${companyId}`)
  },
  fetchAffMailboxesCounts(reportId) {
    return get(`/members-api/irontraps/affmailboxes-counts/${reportId}`)
  },
  getAffectedMailboxData(mitigation_id, companyId = '') {
    return get(
      `/members-api/irontraps/mitigation/${mitigation_id}/details?companyFilter=${companyId}`
    )
  },
  getMitigationData(
    companyFilter = '',
    gmail_message_id,
    office365_message_id,
    message_id,
    recipient_address,
    sender_address,
    subject,
    eid
  ) {
    return get(
      buildURL(`/members-api/irontraps/mitigation/details`, {
        companyFilter,
        gmail_message_id,
        office365_message_id,
        message_id,
        recipient_address,
        sender_address,
        subject,
        eid,
      })
    )
  },
  getCommunityInsights(reportId) {
    return get(`/members-api/community/report-data/${reportId}`)
  },
  getAssignees(companyFilter = '', search = '') {
    return get(
      buildURL('/members-api/irontraps/reports/assignees', {
        companyFilter,
        search,
      })
    )
  },
  changeAssignee(reportId, body, reportTypePrefix) {
    return post(`/members-api/irontraps/reports/${reportTypePrefix}/${reportId}/assign`, body)
  },
  changeAtoAssignee(incidentId, body) {
    return post(`/members-api/irontraps/incidents/${incidentId}/ato-assign`, body)
  },
  fetchScansFreemiumLimit(companyId = '') {
    return get(`/members-api/freemium/scans?companyFilter=${companyId}`)
  },
  fetchRawEmail(reportId, emailType) {
    // validate permissions
    return get(`/members-api/irontraps/reports/${reportId}/${emailType}`)
  },
  fetchThreatLogFilters(companyFilter = '') {
    return get(`/members-api/search/investigation/mapping/?companyFilter=${companyFilter}`)
  },
  fetchThreatLogData(body) {
    return post(`/members-api/search/entity_investigation/`, body)
  },
  fetchLogsEntireCount(companyFilter = '', body) {
    return post(
      `/members-api/search/entity_investigation/count/?companyFilter=${companyFilter}`,
      body
    )
  },
  closeIncident(reportId) {
    return post(`/members-api/release-requests-handled/${reportId}`)
  },
  closeSafeChallengeIncident(reportId) {
    return post(`/members-api/safe-challenged-handled/${reportId}`)
  },
  getEmailSnapshot(reportId) {
    return get(`/members-api/irontraps/incidents/mail/snapshot/${reportId}`)
  },
  downloadIndividualEmail(mitigationId) {
    return get(`/members-api/irontraps/reports/${mitigationId}/download_eml`, 'blob')
  },
  releaseEncryptedIncident(reportId) {
    return post(`/members-api/irontraps/reports/encrypted/${reportId}/release`)
  },
  keepEncryptedIncidentInQuarantine(reportId) {
    return post(`/members-api/irontraps/reports/encrypted/${reportId}/approve`)
  },
  fetchPresets() {
    return get(`/members-api/search/investigation/saved_filters/`)
  },
  createPreset(body) {
    return post(`/members-api/search/investigation/saved_filters/`, body)
  },
  updatePreset(body) {
    return put(`/members-api/search/investigation/saved_filters/`, body)
  },
  removePreset(body) {
    return deleteRest(buildURL(`/members-api/search/investigation/saved_filters/`, body))
  },
  releaseFromInvestigation(body) {
    return post(`/members-api/search/investigation/release_spam_email/`, body)
  },
})
